import dayjs from "dayjs";
import { array, date, object, string } from "yup";
import { ReturnableTypeEnum } from "../returnable-type";
import { StockInModeEnum } from "../stock-in-mode";
import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  returnableId: null, // The source document ID (DO or SI)
  // Reference number of the source invoice; the expense picker resolves an
  // invoice's expense lines by reference number, not by id.
  returnableReferenceNumber: null,
  returnableType: ReturnableTypeEnum.DELIVERY_ORDER,
  stockInMode: StockInModeEnum.FULL, // Default to FULL
  warehouse: null, // Warehouse for NON_INVOICE returns
  note: null,
  returnableProductVariants: [],
  // Expense lines of the source sales invoice being returned (SALES_INVOICE only).
  salesReturnExpenses: [],
  discountAmount: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 11,
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().required("Harus diisi"),
  seller: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  stockInMode: string().required("Harus diisi"),
  warehouse: object().when("returnableType", {
    is: ReturnableTypeEnum.NON_INVOICE,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.nullable(),
  }),
  // A return must carry something, but an invoice return may consist solely of
  // returned expenses — the backend accepts either list being empty, not both.
  returnableProductVariants: array().when("salesReturnExpenses", {
    is: (salesReturnExpenses) => (salesReturnExpenses?.length ?? 0) > 0,
    then: (schema) => schema,
    otherwise: (schema) =>
      schema.min(1, "Harus memiliki setidaknya satu produk"),
  }),
});
